<template>
  <div>
    <b-card
      title="Add Case 🚀"
    >
      <b-card-text>Case will be Added here..</b-card-text>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
  },
}
</script>

<style>

</style>
